export default "__VITE_ASSET__81eae6e5__"